// @ts-nocheck

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CalendarBlank } from '@phosphor-icons/react';
import { getFormattedTripDates } from '../../helpers/dates';
import './Header.css';

const Header = ({ tripData }) => {
  const { tripname, tripimage, tenant, startdate, duration } = tripData || {};
  const imageUrl = tripimage?.[0]?.imageurl;
  const tripDates = getFormattedTripDates(startdate, duration);
  const [manifestIconUrl, setManifestIconUrl] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadManifestIcon = async () => {
      try {
        const manifestLink = document.querySelector('link[rel="manifest"]');
        const manifestUrl = manifestLink?.href;

        if (!manifestUrl) {
          if (isMounted) setManifestIconUrl(null);
          return;
        }

        const response = await fetch(manifestUrl, { cache: 'no-store' });
        if (!response.ok) {
          if (isMounted) setManifestIconUrl(null);
          return;
        }

        const manifest = await response.json();
        const icons = Array.isArray(manifest?.icons) ? manifest.icons : [];

        const preferredIcon =
          icons.find((icon) =>
            String(icon?.sizes || '')
              .split(' ')
              .includes('192x192')
          ) || icons[0];

        const iconSrc = preferredIcon?.src;
        if (!iconSrc) {
          if (isMounted) setManifestIconUrl(null);
          return;
        }

        const absoluteIconUrl = new URL(iconSrc, manifestUrl).toString();
        if (isMounted) setManifestIconUrl(absoluteIconUrl);
      } catch (e) {
        if (isMounted) setManifestIconUrl(null);
      }
    };

    loadManifestIcon();

    return () => {
      isMounted = false;
    };
  }, []);

  const logoSrc = tenant?.tenantlogo || manifestIconUrl;

  return (
    <header className='pwa-header'>
      <div className='pwa-header__background'>
        {imageUrl && (
          <img
            src={imageUrl}
            alt={tripname}
            className='pwa-header__bg-image'
            draggable='false'
          />
        )}

        <div className='pwa-header__overlay'></div>
      </div>
      <div className='pwa-header__content'>
        <div className='pwa-header__trip-info'>
          <h1 className='pwa-header__trip-name'>{tripname || ''}</h1>
          <div className='pwa-header__trip-dates'>
            <CalendarBlank size={22} color='#ffffff' />
            <span className='pwa-header__dates-text'>{tripDates || ''}</span>
          </div>
        </div>
      </div>
      <div className='pwa-header__logo'>
        {logoSrc && (
          <img
            src={logoSrc}
            alt={tenant?.tenantname || 'Logo'}
            className='pwa-header__logo-icon'
            draggable='false'
          />
        )}
      </div>
    </header>
  );
};

Header.propTypes = {
  tripData: PropTypes.shape({
    image: PropTypes.string,
    tripname: PropTypes.string,
    dates: PropTypes.string
  })
};

export default Header;
